module.exports = __webpack_public_path__ + "img/Driving-license.0cf8a9bc.png";